export const minhasConsultasProps = {
  basename: "/plataforma/consultas",
};
